import {sliderAnatomy as parts} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  thumb: {
    bg: 'mld.neutral.900',
  },
})

const primary = definePartsStyle({
  filledTrack: {
    bg: 'mld.neutral.900',
  },
})

export default defineMultiStyleConfig({
  baseStyle,
  variants: {
    primary,
  },
})
